import React, { Component } from 'react';
import _ from 'lodash';
import { convertToLineItem ,configurationSource,hasAnyAssignableValues,translateProperty,deflateModelVariables} from '../../../../util';
import { connect } from 'react-redux';
import { analyticsDispatcher,siteSettingsState, combineDispatchers, productState, productsDispatcher, priceDispatcher, identityState, combineStates, screenSizeState,configuratorDispatcher,configuratorState, filterSelectedDispatcher } from '../../../../store';
import { ProductsViewer, Accordion, SvgImage, ViewSelector,BusyContainer } from '../../../../components';
import { translate ,getLanguages,configuratorActions } from '../../../../services';
import { GreyFilterEmptyIconNew, NewSearchIcon, searchIcon } from '../../../../../style/images';
import { PropTypes } from 'prop-types';
import { Box } from '@mui/material';
import SelectFilterMessage from './SelectFilterMessage';
import { DropdownList } from 'react-widgets';
import { UiGroup } from '../model';
import { AssignmentType } from '../../../../model';
import { Variable } from '../model';
 
const deadValues = ['not applicable', 'not&#032;applicable', 'do not display'];
 
 
const containValidValues = variable => {
  return variable.values
    .any( value => value.state !== 4 && !deadValues.includes( value.title.toLocaleLowerCase( 'en-US' ) ) )
};
 
 
const Filter = ( { title, variable,props,materialKey} ) => {
  if(variable.assignedValue){
    props.setFilterSelected(true);
  }
  else{
    props.setFilterSelected(false);
  }
  const valueFilter = value => {
    const translated = value.title;
    //state 3 - blocked values in model
    return value.name.toLowerCase() !== 'not applicable' && value.state !== 4 && value.state !== 3 && translated?.toLowerCase() !== 'do not display';
  }
 
 
  const  updateSelectedProduct = (e,variable) => {
    const { configurations } = props;    
      const template = configurations[materialKey] && configurations[materialKey][0];
      const source = template.productModelType === 0 ? configurationSource.model : configurationSource.accessories;
    if ( e.state === 1 || e.state === 2 ) {
      props.removeValue( {...template},template,variable.fullyQualifiedName, e.name );
    } else {
       return props.assignValue( { ...template }, template, source === configurationSource.model ? variable.fullyQualifiedName : variable.name,  e.name );
     
    }
 
  }
 
    return  <div className="accessory-selection">
        <div className="selection-field">
          <span className="label">{ translate( variable.properties.EN ) }</span>
          <DropdownList data={ variable.values.filter( valueFilter ) } value={variable.assignedValue} textField="name" onChange={ (e)=>updateSelectedProduct(e,variable) } />
          {/* value={selectedProduct.name} onChange={ (e)=>updateSelectedProduct(e) } */}
        </div>
        {/* { variable.name } */}
      </div>;
 
};
 
export class AccessoryProductListComponent extends Component {
  constructor() {
    super();
    this.state = {
      filter: null,
      searchQuery:null,
      storedQueries: {},
      selectedProduct: {
        name: null
      },
      productFoundForSearch: false //for GA
    };
  }
 
  componentDidMount() {
    const { variables } = this.props;
    const codes = [];
 
    variables.forEach( variable => variable.show && variable.values.forEach( value => value.state === 0 && codes.push( value.name ) ) );
    this.getProducts( codes );
    this.props.setShowResetHeader && this.props.setShowResetHeader()
    this.mounted = true;
  }
 
  componentWillUnmount() {
    this.mounted = false;
  }
 
  getProducts( codes ) {
    if ( this.busy ) {
      return;
    }
 
    this.busy = true;
    this.props.getProducts( codes ).then( () => this.busy = false ).then( () => {
      var filteredCodes = _.chunk( codes.filter( c => this.props.products[c] ), 40 )
      filteredCodes.forEach( pro =>
        this.props.getPrices( pro.map( c => convertToLineItem( this.props.products[c], this.props.user ) ) )
      );
    } );
  }
 
  sendAnalyticsQuery( query ) {
    const { storedQueries } = this.state;
    if ( !query ) {
      return;
    }
    const key = query.toLowerCase();
    if ( storedQueries[key] ) {
      // store query only once (this is per time the searchcomponent gets opened)
      return;
    }
    this.mounted && this.setState( { storedQueries: { ...storedQueries, [key]: true } },
      () => {this.props.captureEvent( 'search', 'search-loose-accessories', query, ['commonTracker'] );
     
      dataLayer.push({
        event: "search",
        event_action:'search-loose-accessoriess',
        event_label : query.toLowerCase().concat(":search-loose-accessories"),
        event_results : this.state.productFoundForSearch,
        event_instance:this.props.siteSettings.properties.GaInstance,
        event_country: this.props.siteSettings.properties.GaCountry,
        location_url:window.location.href
      })  
    } );
  }
 
  getLayout = item => {
    if ( item === null || item.obsolete ) {
      return 'unavailable';
    }
 
    return null;
  }
 
  onSearch = e => {
    const searchQuery = e && e.target && e.target.value && e.target.value.trim && e.target.value.trim();
 
    if ( !searchQuery && !searchQuery.match ) {
      return;
    }
 
    this.isTyping && clearTimeout( this.isTyping );
    this.analyticsCache && clearTimeout( this.analyticsCache );
    this.isTyping = setTimeout( () => this.mounted && this.setState( { searchQuery } ), 500 );
    this.analyticsCache = setTimeout( () => this.sendAnalyticsQuery( searchQuery ), 1000 );
  }
  onGrpProp = (uiGroupsList)=>{
    uiGroupsList.children.filter( variable => variable.show).map( ( variable, key ) => {
    return variable.properties.name;
   })
 }
 
 onGrpTitle = (uiGroupsList)=>{
   uiGroupsList.children.filter( variable => variable.show).map( ( variable, key ) => {
   return variable.properties.title;
  })
 }
  render() {
    const { products, variables, screenSize ,materialKey, assignValue, removeValue ,reset } = this.props;
    const { searchQuery ,selectedProduct} = this.state;
    const uiGroupsList = this.props.configurations[materialKey][0].model.children.filter( group => hasAnyAssignableValues( group ) && group.fullyQualifiedName != 'Availability' );
    const accessories = uiGroupsList[0].children.filter( variable => variable.show).map( ( variable, key ) => {
       // header has a dynamic height
   let header='';
   let translated=[];
   variable.variables.map((val)=>{
    const num = val.values.filter( value => value.state!=4 && products[value.name])
    if(num.length>0){
      header = React.createElement( `h${3}`, null, [
        ( variable.properties.ZH|| variable.properties.EN ),
        reset &&<div> <SvgImage source={ resetIcon } className="reset-icon" onClick={ reset } key={ 2 } />
     {(variable.properties && variable.properties.Info &&variable.properties.Info.substring(0,4)==='http')?<a href={variable.properties.Info} target='blank'> <SvgImage source={ infoIcon }    /> </a>:null}
        </div>
      ] );
     
    }
     })
      let productList=[];
      const isSearchedVariable = searchQuery && ( variable.title.includesCaseInsensitive( searchQuery ) || variable.properties.ZH.includesCaseInsensitive( searchQuery )|| variable.properties.EN.includesCaseInsensitive( searchQuery ))
      if(searchQuery ){
        if(isSearchedVariable){
          variable.variables.map((val)=>{val.values;
            const tmpList = val.values.filter( value => value.state!=4 && products[value.name]).map( value => products[value.name])
              if(tmpList && tmpList.length>0){
                productList.push(tmpList)
                translated.push(val.properties.ZH || val.properties.EN);
              }
              
           })
        }
        else{
          variable.variables.forEach((val1)=>{
         if( val1.title?.includesCaseInsensitive( searchQuery ) || val1.properties?.ZH?.includesCaseInsensitive( searchQuery ) || val1.properties?.EN?.includesCaseInsensitive( searchQuery )){
             const tempprodlst = val1.values.filter( value => value.state!=4 && products[value.name]).map( value => products[value.name]);
             if(tempprodlst && tempprodlst.length>0){
              productList.push(tempprodlst)
             translated.push(val1.properties.ZH || val1.properties.EN)
             }
         }else{
          const prodLst =val1.values.filter(val2=>(products[val2.name]?.code.includesCaseInsensitive( searchQuery ) || val2.title?.includesCaseInsensitive( searchQuery ) ||val2.name?.includesCaseInsensitive( searchQuery ) ) && val2.state!=4 && products[val2.name]).map( value => products[value.name]);
          if(prodLst && prodLst.length>0){
            productList.push(prodLst); 
            translated.push(val1.properties.ZH || val1.properties.EN)
          }
          /*val1.values.forEach( val2=> { 
            if((products[val2.name]?.code.includesCaseInsensitive( searchQuery ) || val2.title?.includesCaseInsensitive( searchQuery ) || val2.properties?.ZH?.includesCaseInsensitive( searchQuery )||val2.name?.includesCaseInsensitive( searchQuery ) ) && val2.state!=4 && products[val2.name]){
                productList.push( products[val2.name])
                 translated.push(val2.properties.ZH || val2.properties.EN)
            }});*/
         }
         })
        }
        
      }
      else
        {
        variable.variables.map((val)=>{val.values;
          productList.push(val.values.filter( value => value.state!=4 && products[value.name]).map( value => products[value.name]))
            translated.push(val.properties.ZH || val.properties.EN);
         })
      }
      if ( searchQuery && !isSearchedVariable ) {
      //  productList = productList.filter( product => product.filter(p=>p?.description?.includesCaseInsensitive( searchQuery ) || p?.name?.includesCaseInsensitive( searchQuery )));
      
      }
      return !productList.length ? null : <Accordion key={ key } className="accessory-product-group">
          {header}
          { productList.map((prodct,idx)=>{if(prodct.length!=0){
         return ( <div>
        <Accordion key={ key } className="accessory-product-subgroup">
        <h3>{`${ translated [idx]} (${ prodct.length })`}</h3>
        <ProductsViewer
          products={ prodct }
          hideHeader
          totalItems={ prodct.length }
          view="looseaccessories"
          useCustomLayout={ this.getLayout }
          className = {screenSize.width<=900?"mobile-grid-view":null}
          looseAccesories={true}
          currentSelector = {this.props.currentSelector}
        />
        </Accordion>
        </div>)}})}
        </Accordion>
      })
const filters = variables.filter( variable => variable.name && variable.show && variable.fullyQualifiedName.split(".").length<=2 && containValidValues( variable ) ).map( variable => {
      const translated = variable.title;
      // translate.push(variable.name);
 
      if (!translated || deadValues.includes( translated?.toLocaleLowerCase( 'en-US' ) ) ) {
        return null;
      }
 
 
    return <Filter
    materialKey={materialKey}
    title={ translated }
    variable={ variable}
    props={this.props}
  />; } );
    const noProductFoundForSearch = accessories.every(item => item === null)
    this.state.productFoundForSearch = !noProductFoundForSearch
 
    return <div className="accessory-product-list">
    <div className="accessory-selection">
       {filters}
       {screenSize.width<=900 && this.props.resetHeader && this.props.resetHeader.map(e=>e.customHeader)}
      </div>
      { accessories.length > 1? <div className="accessory-product-header">
        <div className="accessory-product-search" style={{width:this.props.siteSettings.properties.showViewSelector?"89%":"100%"}}>
          <SvgImage source={ NewSearchIcon } />
          <input placeholder={ translate( 'Search products by product name/code...' ) } onChange={ this.onSearch } />
        </div>
  {this.props.siteSettings.properties.showViewSelector&&screenSize.width>900&&<ViewSelector view="looseaccessories" />}
      </div>:null}
      <div className="accessory-product-results">
        {
          noProductFoundForSearch ? <SelectFilterMessage height={this.props.contentHeight-152-30} heading="No results found" message="Please try typing again" icon={GreyFilterEmptyIconNew}></SelectFilterMessage>
          : <div style={{height:"100%", width:"100%", overflowY:'auto'}}>{ accessories }</div>
        }
      </div>
    </div>;
  }
}
 
AccessoryProductListComponent.propTypes = {
  captureEvent: PropTypes.func.isRequired,
  getPrices: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  products: PropTypes.objectOf( PropTypes.object ),
  variables: PropTypes.arrayOf( PropTypes.shape( {
    values: PropTypes.arrayOf( PropTypes.object )
  } ) ).isRequired
};
 
export const AccessoryProductList = connect(
  combineStates( siteSettingsState, productState, identityState, screenSizeState ,configuratorState),
  combineDispatchers( analyticsDispatcher, priceDispatcher, productsDispatcher,configuratorDispatcher,filterSelectedDispatcher )
)( AccessoryProductListComponent );